import React__default from 'react';
import cn from 'classnames';
import { useProxiedRef } from '../../../utils/hooks/useProxiedRef.js';
import { Column } from '../util/renderColumn.js';

const DefaultEmptyState = () => null;
const BaseTable = /*#__PURE__*/React__default.forwardRef(function BaseTable(props, ref) {
  const tableRef = useProxiedRef(ref);
  const {
    autoFocus,
    children,
    disableSorting: _,
    headerGroups,
    headerRef,
    bodyRef,
    ...otherProps
  } = props;
  React__default.useEffect(() => {
    if (autoFocus && tableRef.current) {
      tableRef.current.focus();
    }
  }, []);
  const className = cn('yt-table flex flex-col focus:yt-focus focus:rounded-sm', props.className);
  return React__default.createElement("div", Object.assign({}, otherProps, {
    role: "table",
    className: className,
    ref: tableRef
  }), React__default.createElement("div", {
    role: "rowgroup",
    className: "yt-table__head",
    ref: headerRef
  }, headerGroups === null || headerGroups === void 0 ? void 0 : headerGroups.map((headerGroup, index) => React__default.createElement("div", {
    key: index,
    role: "row",
    className: "border-grey-light flex h-auto min-h-[2.5rem] w-full select-none border-t-0 border-b-2 font-bold"
  }, headerGroup.headers.map((cell, index) => React__default.createElement(Column, {
    key: index,
    index: index,
    cell: cell
  }))))), React__default.createElement("div", {
    role: "rowgroup",
    className: "yt-table__body",
    ref: bodyRef
  }, children));
});

export { BaseTable, DefaultEmptyState };
//# sourceMappingURL=BaseTable.js.map
